export default [
    {
        path: '/event-calendar-base',
        name: 'event-calendar-base',
        component: () => import ('./pages/Index')
    },
]